import CTopbarTitle from './TopbarTitle.vue'

export { CTopbarTitle }
export default { CTopbarTitle }
